/**
 * Customer dialer — the centerpiece (Calls) of the in-app experience.
 * Wraps the shared `CallingDialer` with the customer chrome
 * (top header + bottom nav).
 */
import { Link } from "react-router-dom";
import { ArrowLeft, Users } from "lucide-react";
import SEO from "@/components/site/SEO";
import CallingDialer from "@/components/customer/CallingDialer";
import CustomerBottomNav from "@/components/customer/CustomerBottomNav";

export default function CustomerDialer() {
  return (
    <div className="min-h-screen bg-brand-bgSoft text-brand-ink pb-36 md:pb-10" data-testid="customer-dialer">
      <SEO title="Calls" path="/app/dial" />
      <header className="bg-white border-b border-brand-line sticky top-0 z-30">
        <div className="container-page flex items-center justify-between h-16">
          <Link to="/app" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-ink/70 hover:text-brand-ink" data-testid="dialer-more-link">
            <ArrowLeft className="h-4 w-4" /> More
          </Link>
          <h1 className="font-display font-black text-base text-brand-ink">Calls</h1>
          <Link to="/app/contacts" data-testid="dialer-header-contacts"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-ink/70 hover:text-brand-ink">
            <Users className="h-4 w-4" />
          </Link>
        </div>
      </header>

      <div className="container-page py-5 sm:py-8">
        <CallingDialer />
      </div>

      <CustomerBottomNav />
    </div>
  );
}
